<template>
    <b-col sm="6" md="4">
        <b-card header="What are widgets?">
            There is simple explanation what <a :href="docsUrl + `/docs#platform-widgets`" target="_blank">widgets</a> are.
        </b-card>
      </b-col>
</template>

<script>
export default {

    data: function() {
        return {
            docsUrl: this.$env.get('DOCS_URL')
        }
    }
}
</script>